import React from "react";
import Slider from "react-rangeslider";
import "react-rangeslider/lib/index.css";


const RangeSelect = ({ name , onChange , value , labels }) => (
  <div className="rangeslidercontent">
    <div className="rangeslidertxt fontExtraLight colorBlack">
        {labels[value][0]}
    </div>
    <div className="rangesliderslide">
      <Slider
        min={0}
        max={3}
        step={1}
        value={value}
        tooltip={false}
        onChange={(e) => onChange(e , labels[e][0] , name, labels[e][1])}
      />
      <div className="rangesliderlabel">
          {labels.map((label, index) => <div className='rangesliderlabeltxt colorBlack fontRegular' key={index} onClick={(e) => onChange(index , label[0] , name, label[1])}>{label[0]}</div>) }
      </div>
    </div>
  </div>
);

export default RangeSelect;



// WEBPACK FOOTER //
// ./src/containers/components/RangeSelect.js